import HTMLElement from '../html-element/HTMLElement.js';
/**
 * HTMLParamElement
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLParamElement
 */
export default class HTMLParamElement extends HTMLElement {}
